//Directive that adds additional "form" properties to support dynamic form validation rules
import { Directive, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { DesignerElementPropertyType } from '@Core/models/proprietary/page/page.state';
import { EvaluatedObjectRules } from '../../../core/services/proprietary/object-rule/object-rule.types';

@Directive({
    selector: 'form',
    standalone: false
})
export class FormValidationDirective {
    _formRules: EvaluatedObjectRules = {};

    @Input('formGroup')
    form: UntypedFormGroup;

    get evaluatedFormRules(): EvaluatedObjectRules {
        return this._formRules;
    }

    @Input()
    set evaluatedFormRules(value: EvaluatedObjectRules) {
        this._formRules = value;
    }

    hidden(formControlPath: string): boolean {
        if (
            this._formRules &&
            this._formRules[formControlPath] &&
            this._formRules[formControlPath].hasOwnProperty('hide')
        ) {
            return this._formRules[formControlPath].hide;
        }
        return false;
    }

    propertyValue(formControlPath: string, propertyType: DesignerElementPropertyType) {
        if (
            this._formRules &&
            this._formRules[formControlPath] &&
            this._formRules[formControlPath].hasOwnProperty(propertyType)
        ) {
            return this._formRules[formControlPath][propertyType];
        }
        return null;
    }

    constructor() { }

    ngOnInit() { }
}
